import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductIconList from 'components/@common/ProductIconList';
import Typography from '@material-ui/core/Typography';
import { StudentLicenseUsage } from 'types/schema-generated-types';

export interface StudentCardContentFragmentProps {
  username: string;
  gradeLevel: string;
  password?: string;
  email?: string;
  group: string;
  licenseUsage?: StudentLicenseUsage[];
}

const StudentCardContentFragment: React.FC<StudentCardContentFragmentProps> = ({
  username,
  password,
  email,
  gradeLevel,
  group,
  licenseUsage
}) => {
  const { t } = useTranslation('ClassroomsTileViewContainer');

  return (
    <>
      <Typography variant="body1">
        {t('Group')}: {group}
      </Typography>
      <Typography>
        {t('User Name')}: {username}
      </Typography>
      <Typography variant="body1">
        {t('Secret Code')}: {password}
      </Typography>
      <Typography variant="body1">
        {t('Email Address')}: {email || ` ${t('No Email Registered')}`}
      </Typography>
      <Typography variant="body1">
        {t('Grade')}: {gradeLevel}
      </Typography>
      <ProductIconList
        licenseUsage={licenseUsage}
        title={t('Products')}
        emptyMessage={t('No assigned products')}
      />
    </>
  );
};

export default StudentCardContentFragment;
